/** @jsx jsx */
import { jsx } from "theme-ui"
import { useCallback } from "react"
import { Box } from "rebass"
import { Field } from "react-final-form-html5-validation"
import { useTranslation } from "react-i18next"

import Button from "../Button"
import Grid from "../../atoms/Grid"
import Form from "../../molecules/Form"

const JoinInForm = ({ agreement, name, email, submit }) => {
  const { i18n } = useTranslation()
  const handleSubmit = useCallback(() => {
    typeof fbq !== "undefined" && window.fbq("track", "CompleteRegistration")
  }, [])

  return (
    <Form
      name="join-in"
      initialValues={{ name: "", email: "", accept: false }}
      onSubmit={handleSubmit}
    >
      {({ values, submitSucceeded, submitting }) => (
        <Grid sx={{ gridTemplateColumns: ["", "repeat(10, 1fr)"] }}>
          <div sx={{ gridColumn: "span 5" }}>
            <Field
              component="input"
              type="text"
              name="name"
              placeholder={name}
              value={values.name}
            />
          </div>
          <div sx={{ gridColumn: "span 5" }}>
            <Field
              component="input"
              type="email"
              name="email"
              placeholder={email}
              required
              value={values.email}
            />
          </div>
          <div sx={{ gridColumn: "span 10" }}>
            <label
              htmlFor="accept"
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <Field
                component="input"
                checked={values.accept}
                sx={{ width: "auto", mt: 1 }}
                type="checkbox"
                name="accept"
                id="accept-checkbox"
              />
              <label
                sx={{
                  ...(i18n.dir() === "rtl" ? { mr: 1} : { ml:1}),
                  fontSize: 1,
                  "p:first-of-type": {
                    m: 0,
                  },
                }}
                htmlFor="accept-checkbox"
              >
                {agreement}
              </label>
            </label>
            <div sx={{ gridColumn: "1 / -1" }}>
              {!submitSucceeded ? (
                <Button
                  disabled={!values.accept || submitting}
                  variant="bigPrimary"
                  sx={{ px: 6, py: 4, mt: 2 }}
                  type="submit"
                >
                  {submit}
                </Button>
              ) : (
                <Box sx={{ py: 4 }}>Thank you!</Box>
              )}
            </div>
          </div>
        </Grid>
      )}
    </Form>
  )
}

export default JoinInForm
